export default __webpack_public_path__ + "static/media/2.57d393bd.png";